import { useMediaQuery } from "@/hooks/useMediaQuery"
import clsx from "clsx"
import { ReactNode } from "react"
import { FormattedMessage } from "react-intl"
import { Button } from "../Button"

type Props = {
  title?: string
  title_id?: string
  children?: ReactNode
  showBuyCoins?: boolean
  contentClass?: string
}

export const PageTitle = ({ title, title_id, children, showBuyCoins = false, contentClass }: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)")
  return (
    <div className={clsx("main-content_top-line", { "flex-column": isMobile })}>
      <div className={clsx("main-content_left", { "flex-column": isMobile })}>
        <div className="div-h1">
          {title}
          {title_id && <FormattedMessage id={title_id} />}
        </div>
        {children && <div className={`main-content_btn ${contentClass}`}>{children}</div>}
      </div>
      {/* onClick={() => window.open(process.env.REACT_APP_BUY_CRYPTO_URL, "_self")} */}
      {showBuyCoins && (
        <Button variant="outlined" className="w-full md:w-auto">
          <FormattedMessage id="buy_coins" />
        </Button>
      )}
    </div>
  )
}
